(function (Drupal, once) {
  Drupal.behaviors.flexyckeditor = {
    attach: function (context, settings) {
      once("CKEditor", ".field--type-text-long .js-form-type-textarea", context).forEach((element) => {
        //Adaptive CKEditor background
        /* if (context.hasAttribute("data-layout-section-background")) {
            const intID = setInterval(() => {
                const labelForCke = element.querySelector('label').htmlFor;

                if (CKEDITOR.instances[labelForCke].document) {
                    const htmlCke =
                        CKEDITOR.instances[
                            labelForCke
                        ].document.getDocumentElement();

                    const bodyCke = htmlCke.getElementsByTag('body').toArray()[0];

                    if (bodyCke) {
                        htmlCke.setStyle(
                            'background',
                            context.getAttribute("data-layout-section-background")
                        );
                        bodyCke.setStyle(
                            'background',
                            context.getAttribute("data-layout-section-background")
                        );
                        clearInterval(intID);
                    }
                }
            }, 150);
        } */

        // Ckeditor background color switcher container
        const buttonContainer = document.createElement("div");
        buttonContainer.classList.add("ckeditor-button-container");

        element.appendChild(buttonContainer);

        // Create label

        const label = document.createElement("div");
        label.classList.add("ckeditor-button-container__label");
        const labelText = document.createTextNode(
          Drupal.t("Ckeditor background color")
        );

        label.appendChild(labelText);
        buttonContainer.appendChild(label);

        // Ckeditor background color switcher buttons

        // White
        const whiteButton = document.createElement("div");
        whiteButton.classList.add("ckeditor-button-container__button");
        const whiteButtonText = document.createTextNode(Drupal.t("White"));
        whiteButton.setAttribute("data-ckeditor-bg-color", "white");

        whiteButton.appendChild(whiteButtonText);
        buttonContainer.appendChild(whiteButton);

        // Checkbox
        const whiteCheckbox = document.createElement("div");
        whiteCheckbox.classList.add("checkbox");
        whiteButton.appendChild(whiteCheckbox);

        // Default

        whiteButton.classList.add('ckeditor-bg-switcher-active');

        // Gray
        const grayButton = document.createElement("div");
        grayButton.classList.add("ckeditor-button-container__button");
        const grayButtonText = document.createTextNode(Drupal.t("Gray"));
        grayButton.setAttribute("data-ckeditor-bg-color", "gray");

        grayButton.appendChild(grayButtonText);
        buttonContainer.appendChild(grayButton);

        // Checkbox
        const grayCheckbox = document.createElement("div");
        grayCheckbox.classList.add("checkbox");
        grayButton.appendChild(grayCheckbox);

        // darkGray
        const darkGrayButton = document.createElement("div");
        darkGrayButton.classList.add("ckeditor-button-container__button");
        const darkGrayButtonText = document.createTextNode(
          Drupal.t("Dark Gray")
        );
        darkGrayButton.setAttribute("data-ckeditor-bg-color", "darkGray");

        darkGrayButton.appendChild(darkGrayButtonText);
        buttonContainer.appendChild(darkGrayButton);

        // Checkbox
        const darkGrayCheckbox = document.createElement("div");
        darkGrayCheckbox.classList.add("checkbox");
        darkGrayButton.appendChild(darkGrayCheckbox);

        // AddEventLister

        const getButtons = element.querySelectorAll(
          ".ckeditor-button-container__button"
        );

        getButtons.forEach((button) => {
          button.addEventListener("click", (event) => {
            const getButtonAttr = button.getAttribute("data-ckeditor-bg-color");
            const labelFor = element.querySelector("label").htmlFor;

            if (window.CKEDITOR) {
              var htmlClass =
              window.CKEDITOR.instances[labelFor].document.getDocumentElement(
                "body"
              );
            } else {
              var htmlClass = element.querySelector('.ck-editor__main');
            }
            
            const findActiveCheckbox = element.querySelectorAll(
              ".ckeditor-bg-switcher-active"
            );

            switch (getButtonAttr) {
              case "white":
                if (window.CKEDITOR) {
                  htmlClass.removeClass("ckeditor-bg-color-gray");
                  htmlClass.removeClass("ckeditor-bg-color-darkgray");
                  htmlClass.addClass("ckeditor-bg-color-white");
                } else {
                  htmlClass.classList.remove("ckeditor-bg-color-gray");
                  htmlClass.classList.remove("ckeditor-bg-color-darkgray");
                  htmlClass.classList.add("ckeditor-bg-color-white");
                }

                findActiveCheckbox.forEach((elm) => {
                  elm.classList.remove("ckeditor-bg-switcher-active");
                });
                whiteButton.classList.add("ckeditor-bg-switcher-active");
                break;
              case "gray":
                if (window.CKEDITOR) {
                  htmlClass.removeClass("ckeditor-bg-color-white");
                  htmlClass.removeClass("ckeditor-bg-color-darkgray");
                  htmlClass.addClass("ckeditor-bg-color-gray");
                } else {
                  htmlClass.classList.remove("ckeditor-bg-color-white");
                  htmlClass.classList.remove("ckeditor-bg-color-darkgray");
                  htmlClass.classList.add("ckeditor-bg-color-gray");
                }

                findActiveCheckbox.forEach((elm) => {
                  elm.classList.remove("ckeditor-bg-switcher-active");
                });
                grayButton.classList.add("ckeditor-bg-switcher-active");
                break;
              case "darkGray":
                if (window.CKEDITOR) {
                  htmlClass.removeClass("ckeditor-bg-color-white");
                  htmlClass.removeClass("ckeditor-bg-color-gray");
                  htmlClass.addClass("ckeditor-bg-color-darkgray");
                } else {
                  htmlClass.classList.remove("ckeditor-bg-color-white");
                  htmlClass.classList.remove("ckeditor-bg-color-gray");
                  htmlClass.classList.add("ckeditor-bg-color-darkgray");
                }

                findActiveCheckbox.forEach((elm) => {
                  elm.classList.remove("ckeditor-bg-switcher-active");
                });
                darkGrayButton.classList.add("ckeditor-bg-switcher-active");
                break;
              default:
                break;
            }
          });
        });
      });
    },
  };
})(Drupal, once);

(function ($, Drupal) {
  if ($.ui) {
    orig_allowInteraction = $.ui.dialog.prototype._allowInteraction;
    $.ui.dialog.prototype._allowInteraction = function (event) {
      if ($(event.target).closest(".cke_dialog").length) {
        return true;
      }
      return orig_allowInteraction.apply(this, arguments);
    };
  }
})(jQuery, Drupal);
